<app-sidenav>
  <router-outlet></router-outlet>
</app-sidenav>
